(ns quuppa.qsm.api-docs.view
  (:require [quuppa.ui.icons :refer [icon]]
            [quuppa.ui.layout :as layout]))

(defn docs-page []
  [layout/section
   [:div.d-flex.flex-row.flex-grow-1
    [:div.content.flex-column.flex-grow-1
     [:div.container.mx-0.p-4
      [:h3 "API docs"]

      [:a.btn.btn-primary
       {:href "/api/api-docs/"
        :target "blank"}
       "Swagger"
       [icon :arrow-up-right.ml-2]]]]]])
